export default __webpack_public_path__ + "static/media/cars.8d6366de.svg";